// extracted by mini-css-extract-plugin
export default {"tooltipScroll":"index_tooltipScroll__Eq2-v"};